import api from "./api";

/* ================= PRODUCTS ================= */

export const fetchFeaturedProducts = async () => {
  try {
    const res = await api.get("/products/featured");
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch featured products"
    );
  }
};

export const fetchProducts = async () => {
  try {
    const res = await api.get("/products");
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch products"
    );
  }
};

export const fetchProductsSearch = async ({ category, search } = {}) => {
  try {
    const res = await api.get("/products/lookFor", {
      params: { category, search },
    });
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch products"
    );
  }
};

export const fetchProductById = async (id) => {
  try {
    const res = await api.get(`/products/${id}`);
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch product"
    );
  }
};

/* ================= ADMIN CRUD ================= */

export const createProduct = async (formData) => {
  try {
    const res = await api.post("/products", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create product"
    );
  }
};

export const editProduct = async (id, formData) => {
  try {
    const res = await api.post(`/products/${id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update product"
    );
  }
};

export const deleteProduct = async (id) => {
  try {
    const res = await api.post(`/products/${id}`,{ _method: "DELETE"});
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete product"
    );
  }
};

/* ================= CATEGORIES ================= */

export const fetchCategories = async () => {
  try {
    const res = await api.get("/categories");
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch categories"
    );
  }
};

export const fetchCategoriesOptions = async () => {
  try {
    const res = await api.get("/categories/options");
    return res.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch category options"
    );
  }
};
